import { render, staticRenderFns } from "./modal-view-pharmacy-orders-step-four.vue?vue&type=template&id=44536c0f&scoped=true"
import script from "./modal-view-pharmacy-orders-step-four.vue?vue&type=script&lang=js"
export * from "./modal-view-pharmacy-orders-step-four.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44536c0f",
  null
  
)

export default component.exports